export enum PreciateEventType {
  PUBLISHED,
  UNPUBLISHED,
  SUBSCRIBED,
  UNSUBSCRIBE,
}

export default PreciateEventType;
